import React from 'react';
import img1 from "../assets/img/bandeau.jpg";

export const Banner = () => {
  return (
    <div className="banner-container">
      <img src={img1} className="back-img" />
      <div className='over-banner center-content'>
        <div className='info-banner'>
          <h3> "Des choses visibles sont faites de choses invisibles et pourtant bien réelles."
            <br />Albert Einstein</h3>
        </div>
      </div>
    </div>
  );
};
